import ClientScoringRules from "../../../components/client-scoring-rules/client-scoring-rules";
import Page from "../../page";

const ClientScoringRulesPage = () => {
  return (
    <Page>
      <ClientScoringRules />
    </Page>
  );
};

export default ClientScoringRulesPage;
